import React from "react"
import Img from "gatsby-image/withIEPolyfill"

export default ({ image, name }) => {
  return <Img fluid={image} alt={name} />
}
